@file:OptIn(InternalResourceApi::class)

package gero.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/gero.composeapp.generated.resources/"

@delegate:ResourceContentHash(793_855_735)
internal val Res.drawable.W24: DrawableResource by lazy {
      DrawableResource("drawable:W24", setOf(
        ResourceItem(setOf(), "${MD}drawable/W24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(670_877_147)
internal val Res.drawable.W24A: DrawableResource by lazy {
      DrawableResource("drawable:W24A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W24A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(905_927_372)
internal val Res.drawable.W25: DrawableResource by lazy {
      DrawableResource("drawable:W25", setOf(
        ResourceItem(setOf(), "${MD}drawable/W25.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-845_326_924)
internal val Res.drawable.W3: DrawableResource by lazy {
      DrawableResource("drawable:W3", setOf(
        ResourceItem(setOf(), "${MD}drawable/W3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-949_190_822)
internal val Res.drawable.W3A: DrawableResource by lazy {
      DrawableResource("drawable:W3A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W3A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-512_853_734)
internal val Res.drawable.W4: DrawableResource by lazy {
      DrawableResource("drawable:W4", setOf(
        ResourceItem(setOf(), "${MD}drawable/W4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_368_521_114)
internal val Res.drawable.W5: DrawableResource by lazy {
      DrawableResource("drawable:W5", setOf(
        ResourceItem(setOf(), "${MD}drawable/W5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_389_266_127)
internal val Res.drawable.W6: DrawableResource by lazy {
      DrawableResource("drawable:W6", setOf(
        ResourceItem(setOf(), "${MD}drawable/W6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(859_865_889)
internal val Res.drawable.W7: DrawableResource by lazy {
      DrawableResource("drawable:W7", setOf(
        ResourceItem(setOf(), "${MD}drawable/W7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-864_756_490)
internal val Res.drawable.W8: DrawableResource by lazy {
      DrawableResource("drawable:W8", setOf(
        ResourceItem(setOf(), "${MD}drawable/W8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-494_950_728)
internal val Res.drawable.W9: DrawableResource by lazy {
      DrawableResource("drawable:W9", setOf(
        ResourceItem(setOf(), "${MD}drawable/W9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_070_071_182)
internal val Res.drawable.W9A: DrawableResource by lazy {
      DrawableResource("drawable:W9A", setOf(
        ResourceItem(setOf(), "${MD}drawable/W9A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_842_188_546)
internal val Res.drawable.X1: DrawableResource by lazy {
      DrawableResource("drawable:X1", setOf(
        ResourceItem(setOf(), "${MD}drawable/X1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_742_880_139)
internal val Res.drawable.X1D46: DrawableResource by lazy {
      DrawableResource("drawable:X1D46", setOf(
        ResourceItem(setOf(), "${MD}drawable/X1D46.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-101_730_637)
internal val Res.drawable.X2: DrawableResource by lazy {
      DrawableResource("drawable:X2", setOf(
        ResourceItem(setOf(), "${MD}drawable/X2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_321_277_733)
internal val Res.drawable.X3: DrawableResource by lazy {
      DrawableResource("drawable:X3", setOf(
        ResourceItem(setOf(), "${MD}drawable/X3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_478_688_071)
internal val Res.drawable.X4: DrawableResource by lazy {
      DrawableResource("drawable:X4", setOf(
        ResourceItem(setOf(), "${MD}drawable/X4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_277_748_661)
internal val Res.drawable.X4A: DrawableResource by lazy {
      DrawableResource("drawable:X4A", setOf(
        ResourceItem(setOf(), "${MD}drawable/X4A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_673_626_811)
internal val Res.drawable.X4B: DrawableResource by lazy {
      DrawableResource("drawable:X4B", setOf(
        ResourceItem(setOf(), "${MD}drawable/X4B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_227_090_869)
internal val Res.drawable.X5: DrawableResource by lazy {
      DrawableResource("drawable:X5", setOf(
        ResourceItem(setOf(), "${MD}drawable/X5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_601_458_117)
internal val Res.drawable.X6: DrawableResource by lazy {
      DrawableResource("drawable:X6", setOf(
        ResourceItem(setOf(), "${MD}drawable/X6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(700_128_755)
internal val Res.drawable.X6A: DrawableResource by lazy {
      DrawableResource("drawable:X6A", setOf(
        ResourceItem(setOf(), "${MD}drawable/X6A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_217_404_096)
internal val Res.drawable.X7: DrawableResource by lazy {
      DrawableResource("drawable:X7", setOf(
        ResourceItem(setOf(), "${MD}drawable/X7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_066_668_736)
internal val Res.drawable.X8: DrawableResource by lazy {
      DrawableResource("drawable:X8", setOf(
        ResourceItem(setOf(), "${MD}drawable/X8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-82_511_489)
internal val Res.drawable.X8A: DrawableResource by lazy {
      DrawableResource("drawable:X8A", setOf(
        ResourceItem(setOf(), "${MD}drawable/X8A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_092_865_877)
internal val Res.drawable.Y1: DrawableResource by lazy {
      DrawableResource("drawable:Y1", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-620_018_844)
internal val Res.drawable.Y1A: DrawableResource by lazy {
      DrawableResource("drawable:Y1A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y1A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_668_911_924)
internal val Res.drawable.Y2: DrawableResource by lazy {
      DrawableResource("drawable:Y2", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_290_580_207)
internal val Res.drawable.Y3: DrawableResource by lazy {
      DrawableResource("drawable:Y3", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-257_719_149)
internal val Res.drawable.Y4: DrawableResource by lazy {
      DrawableResource("drawable:Y4", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(17_443_640)
internal val Res.drawable.Y5: DrawableResource by lazy {
      DrawableResource("drawable:Y5", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_355_265_951)
internal val Res.drawable.Y6: DrawableResource by lazy {
      DrawableResource("drawable:Y6", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-2_038_735_360)
internal val Res.drawable.Y7: DrawableResource by lazy {
      DrawableResource("drawable:Y7", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_855_341_720)
internal val Res.drawable.Y8: DrawableResource by lazy {
      DrawableResource("drawable:Y8", setOf(
        ResourceItem(setOf(), "${MD}drawable/Y8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-727_791_320)
internal val Res.drawable.Z1: DrawableResource by lazy {
      DrawableResource("drawable:Z1", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z1.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_326_426_054)
internal val Res.drawable.Z10: DrawableResource by lazy {
      DrawableResource("drawable:Z10", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z10.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_626_915_248)
internal val Res.drawable.Z11: DrawableResource by lazy {
      DrawableResource("drawable:Z11", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z11.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_035_670_275)
internal val Res.drawable.Z12: DrawableResource by lazy {
      DrawableResource("drawable:Z12", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z12.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(155_897_169)
internal val Res.drawable.Z13: DrawableResource by lazy {
      DrawableResource("drawable:Z13", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z13.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(747_030_772)
internal val Res.drawable.Z14: DrawableResource by lazy {
      DrawableResource("drawable:Z14", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(970_874_240)
internal val Res.drawable.Z15: DrawableResource by lazy {
      DrawableResource("drawable:Z15", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-809_659_395)
internal val Res.drawable.Z15A: DrawableResource by lazy {
      DrawableResource("drawable:Z15A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(262_634_046)
internal val Res.drawable.Z15B: DrawableResource by lazy {
      DrawableResource("drawable:Z15B", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-894_748_018)
internal val Res.drawable.Z15C: DrawableResource by lazy {
      DrawableResource("drawable:Z15C", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_393_754_301)
internal val Res.drawable.Z15D: DrawableResource by lazy {
      DrawableResource("drawable:Z15D", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-25_915_239)
internal val Res.drawable.Z15E: DrawableResource by lazy {
      DrawableResource("drawable:Z15E", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(417_225_909)
internal val Res.drawable.Z15F: DrawableResource by lazy {
      DrawableResource("drawable:Z15F", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_724_479_179)
internal val Res.drawable.Z15G: DrawableResource by lazy {
      DrawableResource("drawable:Z15G", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_293_381_721)
internal val Res.drawable.Z15H: DrawableResource by lazy {
      DrawableResource("drawable:Z15H", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_386_263_967)
internal val Res.drawable.Z15I: DrawableResource by lazy {
      DrawableResource("drawable:Z15I", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z15I.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-245_364_617)
internal val Res.drawable.Z16: DrawableResource by lazy {
      DrawableResource("drawable:Z16", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(854_709_691)
internal val Res.drawable.Z16A: DrawableResource by lazy {
      DrawableResource("drawable:Z16A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_986_879_841)
internal val Res.drawable.Z16B: DrawableResource by lazy {
      DrawableResource("drawable:Z16B", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_393_621_828)
internal val Res.drawable.Z16C: DrawableResource by lazy {
      DrawableResource("drawable:Z16C", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(759_365_253)
internal val Res.drawable.Z16D: DrawableResource by lazy {
      DrawableResource("drawable:Z16D", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_062_523_485)
internal val Res.drawable.Z16E: DrawableResource by lazy {
      DrawableResource("drawable:Z16E", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16E.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(851_006_393)
internal val Res.drawable.Z16F: DrawableResource by lazy {
      DrawableResource("drawable:Z16F", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16F.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-249_500_579)
internal val Res.drawable.Z16G: DrawableResource by lazy {
      DrawableResource("drawable:Z16G", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16G.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_912_730_014)
internal val Res.drawable.Z16H: DrawableResource by lazy {
      DrawableResource("drawable:Z16H", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z16H.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_715_026_280)
internal val Res.drawable.Z2: DrawableResource by lazy {
      DrawableResource("drawable:Z2", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z2.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-837_099_474)
internal val Res.drawable.Z2A: DrawableResource by lazy {
      DrawableResource("drawable:Z2A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z2A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(4_679_466)
internal val Res.drawable.Z2B: DrawableResource by lazy {
      DrawableResource("drawable:Z2B", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z2B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_666_471_500)
internal val Res.drawable.Z2C: DrawableResource by lazy {
      DrawableResource("drawable:Z2C", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z2C.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-493_682_615)
internal val Res.drawable.Z2D: DrawableResource by lazy {
      DrawableResource("drawable:Z2D", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z2D.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-133_968_241)
internal val Res.drawable.Z3: DrawableResource by lazy {
      DrawableResource("drawable:Z3", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z3.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-816_551_639)
internal val Res.drawable.Z3A: DrawableResource by lazy {
      DrawableResource("drawable:Z3A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z3A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_932_089_365)
internal val Res.drawable.Z3B: DrawableResource by lazy {
      DrawableResource("drawable:Z3B", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z3B.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-414_801_374)
internal val Res.drawable.Z4: DrawableResource by lazy {
      DrawableResource("drawable:Z4", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z4.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-705_300_633)
internal val Res.drawable.Z4A: DrawableResource by lazy {
      DrawableResource("drawable:Z4A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z4A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_123_628_971)
internal val Res.drawable.Z5: DrawableResource by lazy {
      DrawableResource("drawable:Z5", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z5.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_430_786_577)
internal val Res.drawable.Z5A: DrawableResource by lazy {
      DrawableResource("drawable:Z5A", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z5A.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(451_791_629)
internal val Res.drawable.Z6: DrawableResource by lazy {
      DrawableResource("drawable:Z6", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z6.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-889_133_339)
internal val Res.drawable.Z7: DrawableResource by lazy {
      DrawableResource("drawable:Z7", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z7.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(453_458_698)
internal val Res.drawable.Z8: DrawableResource by lazy {
      DrawableResource("drawable:Z8", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z8.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_620_354_799)
internal val Res.drawable.Z9: DrawableResource by lazy {
      DrawableResource("drawable:Z9", setOf(
        ResourceItem(setOf(), "${MD}drawable/Z9.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_437_562_503)
internal val Res.drawable.ab01: DrawableResource by lazy {
      DrawableResource("drawable:ab01", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab01.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_949_660_611)
internal val Res.drawable.ab02: DrawableResource by lazy {
      DrawableResource("drawable:ab02", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab02.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_247_418_876)
internal val Res.drawable.ab03: DrawableResource by lazy {
      DrawableResource("drawable:ab03", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab03.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_204_923_021)
internal val Res.drawable.ab05: DrawableResource by lazy {
      DrawableResource("drawable:ab05", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab05.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_796_305_269)
internal val Res.drawable.ab06: DrawableResource by lazy {
      DrawableResource("drawable:ab06", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab06.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(757_955_625)
internal val Res.drawable.ab08: DrawableResource by lazy {
      DrawableResource("drawable:ab08", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab08.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(874_092_067)
internal val Res.drawable.ab14: DrawableResource by lazy {
      DrawableResource("drawable:ab14", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab14.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(460_477_670)
internal val Res.drawable.ab15: DrawableResource by lazy {
      DrawableResource("drawable:ab15", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab15.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_381_464_206)
internal val Res.drawable.ab18: DrawableResource by lazy {
      DrawableResource("drawable:ab18", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab18.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_337_277_572)
internal val Res.drawable.ab20: DrawableResource by lazy {
      DrawableResource("drawable:ab20", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab20.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(191_209_874)
internal val Res.drawable.ab22: DrawableResource by lazy {
      DrawableResource("drawable:ab22", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab22.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-958_508_046)
internal val Res.drawable.ab23: DrawableResource by lazy {
      DrawableResource("drawable:ab23", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab23.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_443_735_545)
internal val Res.drawable.ab24: DrawableResource by lazy {
      DrawableResource("drawable:ab24", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab24.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_038_930_694)
internal val Res.drawable.ab27: DrawableResource by lazy {
      DrawableResource("drawable:ab27", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab27.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-211_368_297)
internal val Res.drawable.ab29: DrawableResource by lazy {
      DrawableResource("drawable:ab29", setOf(
        ResourceItem(setOf(), "${MD}drawable/ab29.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-77_961_163)
internal val Res.drawable.account_tree: DrawableResource by lazy {
      DrawableResource("drawable:account_tree", setOf(
        ResourceItem(setOf(), "${MD}drawable/account_tree.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_973_278_116)
internal val Res.drawable.acqua: DrawableResource by lazy {
      DrawableResource("drawable:acqua", setOf(
        ResourceItem(setOf(), "${MD}drawable/acqua.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-446_370_821)
internal val Res.drawable.alyn_hat_egypt_back: DrawableResource by lazy {
      DrawableResource("drawable:alyn_hat_egypt_back", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_hat_egypt_back.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_483_634_488)
internal val Res.drawable.alyn_hat_egypt_back_accent: DrawableResource by lazy {
      DrawableResource("drawable:alyn_hat_egypt_back_accent", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_hat_egypt_back_accent.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-699_559_960)
internal val Res.drawable.alyn_hat_egypt_left_accent: DrawableResource by lazy {
      DrawableResource("drawable:alyn_hat_egypt_left_accent", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_hat_egypt_left_accent.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_159_613_672)
internal val Res.drawable.alyn_hat_egypt_top: DrawableResource by lazy {
      DrawableResource("drawable:alyn_hat_egypt_top", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_hat_egypt_top.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(260_763_802)
internal val Res.drawable.alyn_hat_egypt_top_accent: DrawableResource by lazy {
      DrawableResource("drawable:alyn_hat_egypt_top_accent", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_hat_egypt_top_accent.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(1_657_512_228)
internal val Res.drawable.alyn_hat_egypt_top_left: DrawableResource by lazy {
      DrawableResource("drawable:alyn_hat_egypt_top_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn_hat_egypt_top_left.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-344_715_292)
internal val Res.drawable.alyn_layer_0_orecchio: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_0_orecchio", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-0-orecchio.webp", -1, -1),
      ))
    }

@delegate:ResourceContentHash(2_014_144_939)
internal val Res.drawable.alyn_layer_10_cry: DrawableResource by lazy {
      DrawableResource("drawable:alyn_layer_10_cry", setOf(
        ResourceItem(setOf(), "${MD}drawable/alyn-layer-10-cry.webp", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable10Resources(map: MutableMap<String, DrawableResource>) {
  map.put("W24", Res.drawable.W24)
  map.put("W24A", Res.drawable.W24A)
  map.put("W25", Res.drawable.W25)
  map.put("W3", Res.drawable.W3)
  map.put("W3A", Res.drawable.W3A)
  map.put("W4", Res.drawable.W4)
  map.put("W5", Res.drawable.W5)
  map.put("W6", Res.drawable.W6)
  map.put("W7", Res.drawable.W7)
  map.put("W8", Res.drawable.W8)
  map.put("W9", Res.drawable.W9)
  map.put("W9A", Res.drawable.W9A)
  map.put("X1", Res.drawable.X1)
  map.put("X1D46", Res.drawable.X1D46)
  map.put("X2", Res.drawable.X2)
  map.put("X3", Res.drawable.X3)
  map.put("X4", Res.drawable.X4)
  map.put("X4A", Res.drawable.X4A)
  map.put("X4B", Res.drawable.X4B)
  map.put("X5", Res.drawable.X5)
  map.put("X6", Res.drawable.X6)
  map.put("X6A", Res.drawable.X6A)
  map.put("X7", Res.drawable.X7)
  map.put("X8", Res.drawable.X8)
  map.put("X8A", Res.drawable.X8A)
  map.put("Y1", Res.drawable.Y1)
  map.put("Y1A", Res.drawable.Y1A)
  map.put("Y2", Res.drawable.Y2)
  map.put("Y3", Res.drawable.Y3)
  map.put("Y4", Res.drawable.Y4)
  map.put("Y5", Res.drawable.Y5)
  map.put("Y6", Res.drawable.Y6)
  map.put("Y7", Res.drawable.Y7)
  map.put("Y8", Res.drawable.Y8)
  map.put("Z1", Res.drawable.Z1)
  map.put("Z10", Res.drawable.Z10)
  map.put("Z11", Res.drawable.Z11)
  map.put("Z12", Res.drawable.Z12)
  map.put("Z13", Res.drawable.Z13)
  map.put("Z14", Res.drawable.Z14)
  map.put("Z15", Res.drawable.Z15)
  map.put("Z15A", Res.drawable.Z15A)
  map.put("Z15B", Res.drawable.Z15B)
  map.put("Z15C", Res.drawable.Z15C)
  map.put("Z15D", Res.drawable.Z15D)
  map.put("Z15E", Res.drawable.Z15E)
  map.put("Z15F", Res.drawable.Z15F)
  map.put("Z15G", Res.drawable.Z15G)
  map.put("Z15H", Res.drawable.Z15H)
  map.put("Z15I", Res.drawable.Z15I)
  map.put("Z16", Res.drawable.Z16)
  map.put("Z16A", Res.drawable.Z16A)
  map.put("Z16B", Res.drawable.Z16B)
  map.put("Z16C", Res.drawable.Z16C)
  map.put("Z16D", Res.drawable.Z16D)
  map.put("Z16E", Res.drawable.Z16E)
  map.put("Z16F", Res.drawable.Z16F)
  map.put("Z16G", Res.drawable.Z16G)
  map.put("Z16H", Res.drawable.Z16H)
  map.put("Z2", Res.drawable.Z2)
  map.put("Z2A", Res.drawable.Z2A)
  map.put("Z2B", Res.drawable.Z2B)
  map.put("Z2C", Res.drawable.Z2C)
  map.put("Z2D", Res.drawable.Z2D)
  map.put("Z3", Res.drawable.Z3)
  map.put("Z3A", Res.drawable.Z3A)
  map.put("Z3B", Res.drawable.Z3B)
  map.put("Z4", Res.drawable.Z4)
  map.put("Z4A", Res.drawable.Z4A)
  map.put("Z5", Res.drawable.Z5)
  map.put("Z5A", Res.drawable.Z5A)
  map.put("Z6", Res.drawable.Z6)
  map.put("Z7", Res.drawable.Z7)
  map.put("Z8", Res.drawable.Z8)
  map.put("Z9", Res.drawable.Z9)
  map.put("ab01", Res.drawable.ab01)
  map.put("ab02", Res.drawable.ab02)
  map.put("ab03", Res.drawable.ab03)
  map.put("ab05", Res.drawable.ab05)
  map.put("ab06", Res.drawable.ab06)
  map.put("ab08", Res.drawable.ab08)
  map.put("ab14", Res.drawable.ab14)
  map.put("ab15", Res.drawable.ab15)
  map.put("ab18", Res.drawable.ab18)
  map.put("ab20", Res.drawable.ab20)
  map.put("ab22", Res.drawable.ab22)
  map.put("ab23", Res.drawable.ab23)
  map.put("ab24", Res.drawable.ab24)
  map.put("ab27", Res.drawable.ab27)
  map.put("ab29", Res.drawable.ab29)
  map.put("account_tree", Res.drawable.account_tree)
  map.put("acqua", Res.drawable.acqua)
  map.put("alyn_hat_egypt_back", Res.drawable.alyn_hat_egypt_back)
  map.put("alyn_hat_egypt_back_accent", Res.drawable.alyn_hat_egypt_back_accent)
  map.put("alyn_hat_egypt_left_accent", Res.drawable.alyn_hat_egypt_left_accent)
  map.put("alyn_hat_egypt_top", Res.drawable.alyn_hat_egypt_top)
  map.put("alyn_hat_egypt_top_accent", Res.drawable.alyn_hat_egypt_top_accent)
  map.put("alyn_hat_egypt_top_left", Res.drawable.alyn_hat_egypt_top_left)
  map.put("alyn_layer_0_orecchio", Res.drawable.alyn_layer_0_orecchio)
  map.put("alyn_layer_10_cry", Res.drawable.alyn_layer_10_cry)
}
